import { createFileRoute } from '@tanstack/react-router'
import SettingsMembersPage from '@/components/pages/Settings/team/SettingsMembersPage/SettingsMembersPage'

export const Route = createFileRoute('/$workspaceName/$environment/team-settings/members')({
  component: MembersSettingsRoute,
})

function MembersSettingsRoute() {
  return <SettingsMembersPage />
}
